import { render, staticRenderFns } from "./AudioSidebar.vue?vue&type=template&id=7383f013&"
import script from "./AudioSidebar.vue?vue&type=script&lang=js&"
export * from "./AudioSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AudioSidebar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports